import $ from "jquery";

function initializeCharacterCount() {
    $("[data-char-count]").each(function (_, element) {
        const input = element as HTMLInputElement;

        const $element = $(element);
        const $counterLabel = $("<span style='position: absolute; inset-inline-end: 0; inset-block-start: 0;'></span>");
        const limit = Number($element.data("char-count"));

        $element.removeAttr("data-char-count");

        $element.before($counterLabel);
        $counterLabel.text(`${input.value.length} / ${limit.toLocaleString()} Characters`);

        $element.on("input propertychange", function () {
            const input2 = this as HTMLInputElement;

            const curLength = input2.value.length;
            $counterLabel.text(`${curLength} / ${limit.toLocaleString()} Characters`);
        });
    });
}

const observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
        if (mutation.addedNodes) {
            mutation.addedNodes.forEach(function (node) {
                if (node.nodeType === 1 && node.nodeName === "FORM") {
                    initializeCharacterCount();
                }
            });
        }
    });
});

const config = { childList: true, subtree: true };

observer.observe(document, config);

$(initializeCharacterCount);
